import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTrigger } from "@tellescope/ui";
import { Button } from "@tellescope/design-system";
import { ExistingFilePickerDialogContents } from "./ExistingFilePickerDialogContents";
import type { UploadedValueItem } from "./useFileFieldLogic";

export interface ExistingFilePickerButtonProps {
  enduserId: string;
  excludedSecureNames?: string[];
  validFileTypes?: string[];
  multiple: boolean;
  onSelect: (files: UploadedValueItem[]) => void;
}

export const ExistingFilePickerButton = ({
  enduserId,
  excludedSecureNames,
  validFileTypes,
  multiple,
  onSelect,
}: ExistingFilePickerButtonProps) => {
  const { t } = useTranslation("forms");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button type="button" variant="link" size="sm" className="px-0">
          {multiple
            ? t("Or select existing files from this contact")
            : t("Or select an existing file from this contact")}
        </Button>
      </DialogTrigger>
      <ExistingFilePickerDialogContents
        key={String(isOpen)}
        enduserId={enduserId}
        excludedSecureNames={excludedSecureNames}
        validFileTypes={validFileTypes}
        multiple={multiple}
        onSelect={(files) => {
          onSelect(files);
          setIsOpen(false);
        }}
        onCancel={() => setIsOpen(false)}
        isOpen={isOpen}
      />
    </Dialog>
  );
};
